import { Box, Button, Stack, Grid, styled } from "@mui/material";

export const HeadRow = styled(Box)({
  height: "60px",
  display: "grid",
  gridTemplateColumns: "3% 32% 10% 10% 10% 12% 16% 6%",
  borderRadius: "10px",
  margin: "5px",
  backgroundColor: "#4daf51",
  color: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
  alignItems: "center",
  justifyContent: "center",
});
export const ValuesRow = styled(Box)({
  height: "65px",
  display: "grid",
  gridTemplateColumns: "3% 28% 12% 9% 9% 9% 12% 4% 2% ",
  borderRadius: "10px",
  margin: "5px",
  backgroundColor: "white",
  color: "black",
  boxShadow: "0px 3px 6px #c2c1c1",
  color: "#757575",
  alignItems: "center",
  justifyContent: "center",
});

export const ItemBox = styled(Box)({
  alignItems: "center",
  borderRadius: "5px",
  boxShadow: "0px 2px 5px #c2c1c1",
  background: "#ffffff !important",
  display: "grid",
  gridTemplateColumns: "5% 45% 10% 15% 15% 10%",
  color: "#5f5f5f",
  cursor: "pointer",
  marginTop: "5px",
  height: "80px",
});
export const TotalBox = styled(Box)({
  backgroundColor: "white",
  borderRadius: "10px",
  margin: "5px",
  padding: "4px  15px",
  boxShadow: "0px 3px 6px #c2c1c1",
  color: "#757575",
});
export const ReturnButton = styled(Button)({
  color: "white",
  borderRadius: "5px",
  height: "40px",
  cursor: "pointer",
  boxShadow: "0px 3px 6px #c2c1c1",
  textTransform: "none",
  marginTop: "5px",
});

export const BillBox = styled(Grid)(({ theme }) => ({
  backgroundColor: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
  padding: "4px",
  margin: "2px",
  marginBottom: "5px",
  borderRadius: "5px",
  height: "160px",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("lg")]: {
    height: "160px",
    paddingLeft: "10px",
  },
  [theme.breakpoints.down("md")]: {
    height: "200px",
    paddingLeft: "10px",
  },
}));
export const IconBox = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  padding: "0px 5%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-evenly",
}));
export const StackBox = styled(Stack)(({ theme }) => ({
  rowGap: 10,
  alignItems: "flex-start",
  justifyContent: "space-evenly",
  [theme.breakpoints.down("lg")]: {
    rowGap: 15,
  },
  [theme.breakpoints.down("md")]: {
    rowGap: 1,
  },
}));
export const TitleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: 5,
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
  },
}));
